import React, { useState, useEffect, useRef } from "react";
import { Bell, User, Menu, LogOut } from "lucide-react";
import { useNavigate } from "react-router-dom";
import "./Header.css";

export default function Header({ onMenuClick }) {
  const navigate = useNavigate();

  const [username, setUsername] = useState("Admin");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);

  const [newOrdersCount, setNewOrdersCount] = useState(0);
  const [hasPendingNotification, setHasPendingNotification] = useState(false);

  const wsRef = useRef(null);
  const reconnectTimerRef = useRef(null);

  /* JWT username */
  useEffect(() => {
const token = localStorage.getItem("access");
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split(".")[1]));
        setUsername(payload.username || "Admin");
      } catch {
        setUsername("Admin");
      }
    }
  }, []);

  /* WebSocket (unchanged) */
  useEffect(() => {
    const connect = () => {
      const protocol = window.location.protocol === "https:" ? "wss:" : "ws:";
      const ws = new WebSocket(
        `${protocol}//${window.location.host}/ws/orders/`,
      );
      wsRef.current = ws;

      ws.onmessage = (e) => {
        const msg = JSON.parse(e.data);
        if (msg.type === "order_created") {
          setNewOrdersCount((p) => p + 1);
          setHasPendingNotification(true);
        }
      };

      ws.onclose = () => {
        reconnectTimerRef.current = setTimeout(connect, 4000);
      };
    };

    connect();
    return () => wsRef.current?.close();
  }, []);

  const handleBellClick = () => {
    setNewOrdersCount(0);
    setHasPendingNotification(false);
    navigate("/admin/orders");
  };

  const confirmLogout = () => {
    // Remove ONLY auth + role (do not wipe everything blindly)
    localStorage.removeItem("user_role");
    localStorage.removeItem("access");
    localStorage.removeItem("refresh");

    sessionStorage.removeItem("access_token"); // if you still use it
    sessionStorage.removeItem("refresh_token"); // optional

    window.location.href = "/";
  };

  return (
    <>
      <header className="admin-header">
        <div className="header-left">
          <button className="menu-btn" onClick={onMenuClick}>
            <Menu size={20} />
          </button>
          <span className="company-name">TAKO</span>
        </div>

        <div className="header-right">
          <button className="icon-btn" onClick={handleBellClick}>
            <Bell size={20} />
            {newOrdersCount > 0 && (
              <span className="badge">
                {newOrdersCount > 99 ? "99+" : newOrdersCount}
              </span>
            )}
            {hasPendingNotification && newOrdersCount === 0 && (
              <span className="pulse-dot" />
            )}
          </button>

          <div className="profile-container">
            <div
              className="profile"
              onClick={() => setDropdownOpen(!dropdownOpen)}
            >
              <User size={18} />
              <span className="profile-name">{username}</span>
            </div>

            {dropdownOpen && (
              <div className="profile-dropdown">
                <button
                  className="dropdown-item"
                  onClick={() => setShowLogoutConfirm(true)}
                >
                  <LogOut size={16} /> Logout
                </button>
              </div>
            )}
          </div>
        </div>
      </header>

      {showLogoutConfirm && (
        <div className="modal-overlay">
          <div className="confirm-modal">
            <h3>Confirm Logout</h3>
            <p>Are you sure you want to log out?</p>
            <div className="modal-buttons">
              <button className="btn-confirm" onClick={confirmLogout}>
                Yes, Logout
              </button>
              <button
                className="btn-cancel"
                onClick={() => setShowLogoutConfirm(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
